import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
import { OrderConfirmationViewModel, SubscriptionOrderNo, CheckoutSummaryViewModel, ShippingAddress, PaymentViewModel } from '../../../models/check-out.model';
import { CartDetailViewModel } from '../../../models/cart-item.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { CommonService } from '../../../services';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SimpleMsgPopupComponent } from '../../../popup-collection/simple-msg/simple-msg-popup.component';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css']
})
export class OrderConfirmationComponent implements OnInit {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  orderConfirmationInfo: OrderConfirmationViewModel;
  cartId: string;
  title = 'Order Confirmation';
  subscriptionOrderNo: number = parseInt(SubscriptionOrderNo);
  checkoutSummary: CheckoutSummaryViewModel;
  deliverySummary: ShippingAddress;
  paymentSummary: PaymentViewModel;
  partshipSummary: ShippingAddress;
  cartDetails: CartDetailViewModel[];
  domainName: string = window.location.host;
  setFullWindow = false;
  loadContent = false;
  url: string;

  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private store: Store<AppState>
    , private checkOutService: CheckOutService
    , private dialog: MatDialog
    , private commonService: CommonService) { }

  ngOnInit() {

    this.loadContent = false;

    $('.page-contents').animate({
      scrollLeft: ($('#levelOne').outerWidth() + $('#cart-summary').outerWidth())
    }, 400);

    this.activatedRoute.parent.url
      .subscribe(value => {
        this.cartId = value.length > 1 ? value[1].path : '';

        this.getConfirmationDetails();
      },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

  }

  getConfirmationDetails() {

    this.checkOutService.OrderConfirmation(this.commonService.toNumber(this.cartId), '').pipe(take(1)).subscribe((res: OrderConfirmationViewModel) => {
      this.orderConfirmationInfo = res;

      if (res?.shippingAddress?.collectOrder === 'Yes') {
        this.dialog.open(SimpleMsgPopupComponent, {
          width: '400px',
          data: {
            title: 'Collect Order',
            msg: 'Order can only be collected after invoice has been generated.'
          }
        })
      }

      this.deliverySummary = this.orderConfirmationInfo.shippingAddress;
      this.paymentSummary = this.orderConfirmationInfo.payment;
      this.partshipSummary = this.orderConfirmationInfo.shippingAddress;
      this.cartDetails = this.orderConfirmationInfo.cartDetail;
      this.loadContent = true;
      this.commonService.applyScrollFixedHeader(this.parentWrapper);
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  goToManageSubscription() {
    this.router.navigateByUrl(`/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/${this.orderConfirmationInfo.tenantId}`);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/myCarts');
  }
}
